import { storage } from "@/CommonDP/utils";

function getObjectFromSessionStorage(name) {
  const json = storage.get(name);
  return json ? JSON.parse(json) : {};
}
function getisShowMyEnterprise(name) {
  return storage.get(name);
}
import { setToken, getToken } from "@/CommonDP/utils/index.js";
import { gettouxAvatar } from "@/CommonDP/utils/index";
import request from "@/CommonDP/service/login-service";
const user = {
  state: {
    token: getToken("token"),
    userInfo: getObjectFromSessionStorage("userInfo"),
    userId: getisShowMyEnterprise("userId"),
    permission: "",
    name: getObjectFromSessionStorage("userInfo").name,
    avatar: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
    },
    SET_USERID: (state, userId) => {
      state.userId = userId;
      storage.set("userId", userId || "");
    },
    SET_USERINFO: (state, data) => {
      state.userInfo = data;
      storage.set("userInfo", data ? JSON.stringify(data) : "");
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_LOGINNAME: (state, username) => {
      state.username = username;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    CLEAR_STORAGE: (state) => {
      storage.clear();
    }
  },

  actions: {
    setUserInfo({ commit }, data) {
      commit("SET_TOKEN", data.token);
      commit("SET_USERID", data.userId);
      commit("SET_NAME", data.name);
      commit("SET_LOGINNAME", data.username);
      commit("SET_USERINFO", data);
    },
    clearStorage({ commit }) {
      commit("CLEAR_STORAGE");
    },
    // 获取用户信息
    async GetUserInfo({ commit, state }) {
      if (state.userId !== "" && state.userInfo && state.userInfo.currentEnterpriseId) {
        return { data: state.userInfo };
      }
      const response = await request.getUserInfo();
      const data = response.data;
      /** *****
       * 照防 用户登录时逻辑 ，
       * 防止莫名其妙拿不到用户信息数据
       * 如果后续用户登录的逻辑取消了
       * 这块可以删除
       * ********** */
      /** *end **********************/
      // 验证返回的roles是否是一个非空数组
      commit("SET_NAME", data.name);
      commit("SET_LOGINNAME", data.username);
      commit("SET_USERID", data.userId);
      commit("SET_USERINFO", data);
      return response;
    },
    // 前端 登出
    // FedLogOut({ commit }) {
    //   return new Promise(resolve => {
    //     commit("SET_TOKEN", "");
    //     removeToken();
    //     resolve();
    //   });
    // },
    // 登录获取用户头像
    async getUserAvata({ commit }) {
      const store = require("@/store/index").default;
      const res = await request.getUserAvata();
      const userId = store.state.user.userId || store.state.user.userInfo.userId;
      var img = "";
      if (res.data) {
        img = gettouxAvatar(userId);
      } else {
        img = "";
      }
      commit("SET_AVATAR", img);
    },
    logoutInfo({ commit }) {
      commit("SET_NAME", []);
      commit("SET_AVATAR", "");
    }
  }
};

export default user;
